module.exports = __webpack_public_path__ + "static/media/seguradora_yelum.52b8f63c.svg";